export const makeNumbersFarsi = (str: string | number | undefined) => {
  if (typeof str === 'number' || typeof str === 'string') {
    str = str.toString()
  } else {
    return ''
  }

  var farsiNumbers = ['۰', '۱', '۲', '۳', '۴', '۵', '۶', '۷', '۸', '۹']
  for (var i = 0; i < 10; i++) {
    str = str.replace(RegExp(i.toString(), 'g'), farsiNumbers[i])
  }
  return str
}

export const makeNumbersLatin = (str: any) => {
  if (typeof str !== 'string') {
    throw new Error('The input should be a string')
  }

  var farsiNumbers = ['۰', '۱', '۲', '۳', '۴', '۵', '۶', '۷', '۸', '۹']
  var arabicNumbers = ['٠', '١', '٢', '٣', '٤', '٥', '٦', '٧', '٨', '٩']
  for (var i = 0; i < 10; i++) {
    str = str.replace(RegExp(farsiNumbers[i], 'g'), i)
    str = str.replace(RegExp(arabicNumbers[i], 'g'), i)
  }
  return str
}

export const makeArabicCharactersFarsi = (str: string) => {
  if (typeof str !== 'string') {
    throw new Error('The input should be a string')
  }

  str = str.replace(
    RegExp(String.fromCharCode(1603), 'g'),
    String.fromCharCode(1705),
  )
  str = str.replace(
    RegExp(String.fromCharCode(1610), 'g'),
    String.fromCharCode(1740),
  )
  return str
}

export function toEnglishDigits(str: string): string {
  return str.replace(/[۰-۹]/g, (d) => String('۰۱۲۳۴۵۶۷۸۹'.indexOf(d)))
}
